import { render, staticRenderFns } from "./RoleLib.vue?vue&type=template&id=7a53f547&scoped=true"
import script from "./RoleLib.vue?vue&type=script&lang=js"
export * from "./RoleLib.vue?vue&type=script&lang=js"
import style0 from "./RoleLib.vue?vue&type=style&index=0&id=7a53f547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53f547",
  null
  
)

export default component.exports